import { Select, SelectOption, SelectProps } from '@bloomfieldrobotics/canopy';
import { useMemo } from 'react';
import { useVarietiesByCustomer } from '../../../../services/entities/hooks/useVarietiesByCustomer';
import { CropType } from '../../../../services/entities/impl/blfApi/schemas/variety';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
type Props = {
  customerId?: string;
  value?: string | null;
  onChange?: SelectProps<string>['onChange'];
  cropType?: CropType;
  disabled?: boolean;
  label?: string;
};

export const VarietySelect = ({
  customerId,
  value,
  onChange,
  cropType,
  disabled,
  label,
}: Props) => {
  const { t } = useTranslation();

  const { options, loading } = useVarietyOptions(customerId, cropType);

  return (
    <Select
      value={value ?? ''}
      onChange={onChange}
      options={options ?? []}
      loading={loading}
      label={label ?? t('Select variety')}
      disabled={disabled}
    />
  );
};

const useVarietyOptions = (
  customerId?: string,
  cropType?: CropType
): { options: SelectOption<string>[] | undefined; loading: boolean } => {
  const { varieties, isVarietiesLoading: isLoading } = useVarietiesByCustomer(
    customerId,
    cropType
  );

  return useMemo(
    () => ({
      options: varieties?.map((variety) => ({
        value: variety.id,
        label: variety.name,
      })),
      loading: isLoading,
    }),
    [varieties, isLoading]
  );
};
